import React from "react";
import PropTypes from "prop-types";
import { ImageTile } from "@gonoodle/gn-universe-ui";
import { useRouter } from "next/router";
import { ImageSourcesType } from "@gonoodle/gn-universe-ui/types";

import { Link } from "../../containers";
import { getUtmParamsFromQueryParams } from "../../utils/analytics";

export default function CustomLinkCardTile({
  sources,
  title,
  description,
  linkParams,
  format,
  customLinkTitle,
  destinationUrl,
}) {
  const router = useRouter();
  return (
    <Link
      events={[
        {
          event: "Link Clicked",
          properties: {
            sourceElement: linkParams?.sourceElement,
            sourceName: linkParams?.sourceName,
            sourcePage: linkParams?.sourcePage,
            sourcePageType: linkParams?.sourcePageType,
            title,
            url: destinationUrl,
            ...getUtmParamsFromQueryParams(router.query),
          },
        },
      ]}
      href={destinationUrl}
    >
      <ImageTile
        alt={title}
        title={customLinkTitle}
        format={format}
        description={description}
        sources={sources}
      />
    </Link>
  );
}

CustomLinkCardTile.propTypes = {
  title: PropTypes.string,
  sources: ImageSourcesType.isRequired,
  description: PropTypes.string.isRequired,
  linkParams: PropTypes.shape({
    sourceElement: PropTypes.string,
    sourceName: PropTypes.string,
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
  }),
  format: PropTypes.oneOf(["landscape", "square", "portrait"]),
  customLinkTitle: PropTypes.string.isRequired,
  destinationUrl: PropTypes.string.isRequired,
};

CustomLinkCardTile.defaultProps = {
  title: "",
  linkParams: {},
  format: "landscape",
};
